// removed by extract-text-webpack-plugin
module.exports = {"contactUs":"SimpleContactUs__contactUs","title":"SimpleContactUs__title","contactUsByEmail":"SimpleContactUs__contactUsByEmail","contactUsByAddress":"SimpleContactUs__contactUsByAddress","growDotQello":"SimpleContactUs__growDotQello","growDotBlue":"SimpleContactUs__growDotBlue","growDotGolden":"SimpleContactUs__growDotGolden"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ContactUs/SimpleContactUs.scss
// module id = 1847
// module chunks = 0